import moment from 'moment';

export default {
    apiUrl() {
        var baseUrl = (process.env.VUE_APP_ENV == 'local' ? 'http://localhost:3000/api' : window.location.origin + '/api');
        return baseUrl;
    },
    frontUrl() {
        var baseUrl = (process.env.VUE_APP_ENV == 'local' ? 'http://localhost:8080/#' : window.location.origin+'/#')
        return baseUrl;
    },
    monthName(month) {
        var list = ["December Last Year","January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December",];
        return list[month];
    },
    calcRange(range) {

        var start = moment(new Date).format('yyyy-MM-DD');
        var end = moment(new Date).format('yyyy-MM-DD');
        var label = ''
        if (range == 'thisweek') {
            start   = moment(new Date).startOf('week').format('yyyy-MM-DD');
            end     = moment(new Date).endOf('week').format('yyyy-MM-DD');
            label = `This Week (${moment(start).format('DD MMM YY')}' until ${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'lastweek') {
            start   = moment(new Date).subtract(1, "week").startOf('week').format('yyyy-MM-DD');
            end     = moment(new Date).subtract(1, "week").endOf('week').format('yyyy-MM-DD');
            label = `Last Week (${moment(start).format('DD MMM YY')}' until ${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'lastmonth') {
            start   = moment(new Date).subtract(1, "month").startOf('month').format('yyyy-MM-DD');
            end     = moment(new Date).subtract(1, "month").endOf('month').format('yyyy-MM-DD');
            label   = `Last Month (${moment(start).format('MMM YY')}')`
        }
        if (range == 'thismonth') {
            start   = moment(new Date).startOf('month').format('yyyy-MM-DD');
            end     = moment(new Date).endOf('month').format('yyyy-MM-DD');
            label   = `This Month (${moment(start).format('MMM YY')}')`
        }
        if (range == 'today') {
            start  = moment(new Date).format('yyyy-MM-DD');
            end = moment(new Date).format('yyyy-MM-DD');
            label = `Today (${moment(start).format('DD MMM YY')}')`
        }
        if (range == 'yesterday') {
            start  = moment(new Date).subtract(1, "days").format("yyyy-MM-DD");
            end = moment(new Date).format('yyyy-MM-DD');
            label = `Yesterday (${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'last7days') {
            start  = moment(new Date).subtract(7, "days").format("yyyy-MM-DD");
            end = moment(new Date).format('yyyy-MM-DD');
            label = `Last 7 days (${moment(start).format('DD MMM YY')}' until ${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'last15days') {
            start = moment(new Date).subtract(15, "days").format("yyyy-MM-DD");
            end = moment(new Date).format('yyyy-MM-DD');
            label = `Last 15 days (${moment(start).format('DD MMM YY')}' until ${moment(end).format('DD MMM YY')}')`
        }
        if (range == 'last30days') {
            start = moment(new Date).subtract(30, "days").format("yyyy-MM-DD");
            end = moment(new Date).format('yyyy-MM-DD');
            label = `Last 30 days (${moment(start).format('DD MMM YY')}' until ${moment(end).format('DD MMM YY')}')`
        }

        return { start, end, label };
    },
    horaParaDecimal(num) {
        try { 
            var str = num.toString().padStart(4, "0");
            var hours = parseInt(str.slice(0, -2), 10);
            var minutes = parseInt(str.slice(-2), 10);
            if (minutes >= 60) {
                return null;
            }
            return hours + minutes / 60;
        } catch{
            return null;
        }
    },
    numberToTime(hours) {

        if (hours == 0)
            return '00:00';
        
        // Calcula o total de minutos a partir do decimal de horas
        const minutos = Math.ceil(hours * 60);
        
        // Cria um objeto Moment com o tempo equivalente em minutos
        const duration = moment.duration(minutos, 'minutes');
        
        // Formata a duração em horas e minutos
        const horas = Math.floor(duration.asHours());
        const minutosRestantes = duration.minutes();
        
        return `${String(horas).padStart(2, '0')}:${String(minutosRestantes).padStart(2, '0')}`;
    },
    uuid(prefix) {
        prefix = prefix || "TEMP_";
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return `${prefix}${uuid}`;
    },
    countries() {
        return ["United States"];
        //return [ "Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas (the)", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia (Plurinational State of)", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (the)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands (the)", "Central African Republic (the)", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands (the)", "Colombia", "Comoros (the)", "Congo (the Democratic Republic of the)", "Congo (the)", "Cook Islands (the)", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Côte d'Ivoire", "Denmark", "Djibouti", "Dominica", "Dominican Republic (the)", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands (the) [Malvinas]", "Faroe Islands (the)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories (the)", "Gabon", "Gambia (the)", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (the)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic (the)", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands (the)", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia (Federated States of)", "Moldova (the Republic of)", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands (the)", "New Caledonia", "New Zealand", "Nicaragua", "Niger (the)", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands (the)", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines (the)", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of North Macedonia", "Romania", "Russian Federation (the)", "Rwanda", "Réunion", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan (the)", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan (Province of China)", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands (the)", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates (the)", "United Kingdom of Great Britain and Northern Ireland (the)", "United States Minor Outlying Islands (the)", "United States of America", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela (Bolivarian Republic of)", "Viet Nam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe" ]
    },
    formatHuman3(date) {
        if (date == null) {
            return "-";
        }
        moment.locale('en-us');
        var end =  moment(moment.utc(date).local(true));
        return end.format('D/M/YYYY hh:mm A');
    },
    capitalizeFirstLetter(str) {
        try {
            str = str.toLowerCase();
            return str.replace(/\b\w/g, function(char) {
                return char.toUpperCase().trim();
            });
        } catch {
            return str;
        }
    },
    onlyDate(date) {
        if (date == null) {
            return "-";
        }
        moment.locale('en-us');
        var end =  moment(moment.utc(date).local(true));
        return end.format('MM/DD/yyyy');
    },

    onlyDate5(date) {
        if (date == null) {
            return "-";
        }
        moment.locale('en-us');
        var end =  moment(moment.utc(date).local(true));
        return end.format('DD MMM');
    },
    onlyHour(date) {
        if (date == null) {
            return "-";
        }
        moment.locale('en-us');
        var end =  moment(moment.utc(date).local(true));
        return end.format('hh:mm A');
    },
    formatHuman2(date) {
        if (date == null) {
            return "-";
        }
        moment.locale('en-us');
        var end =  moment(moment.utc(date).local(true));
        return end.format('MMM D YYYY hh:mm A');
    },
    formatHuman1(date) {
        if (date == null) {
            return "-";
        }
        moment.locale('en-us');
        var end =  moment(moment.utc(date).local(true));
        return end.format('MMM D YYYY');
    },
    md5(str) {
        var MD5 = function(d){var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}
        var result = MD5(str);
        return result;
    },
    diffDateHumanized(date){
        moment.locale('en-us');
        var now =   moment(moment.utc(date).local(true));
        var end =  moment(moment.utc(new Date()).local(true));
        var duration = moment.duration(now.diff(end));
        return duration.humanize(true);
    },
}